import React, { FunctionComponent } from "react";

const Spinner: FunctionComponent = () => <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" />;

export default Spinner;
